var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15184_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 0.648437L19.1244 5.9603L23.5966 2.21824L23.4592 8.04783L29.1121 6.61673L26.459 11.8094L32.173 12.9727L27.5296 16.5L32.173 20.0274L26.459 21.1907L29.1121 26.3834L23.4592 24.9523L23.5966 30.7819L19.1244 27.0398L16.7188 32.3517L14.3132 27.0398L9.84104 30.7819L9.97838 24.9523L4.32551 26.3834L6.97861 21.1907L1.26462 20.0274L5.908 16.5L1.26462 12.9727L6.97861 11.8094L4.32551 6.61673L9.97838 8.04783L9.84104 2.21824L14.3132 5.9603L16.7188 0.648437Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15184_3988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7032,
    height: 31.7032,
    fill: "white",
    transform: "translate(0.71875 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape7);
export default __webpack_public_path__ + "static/media/shape7.edda60c4bd1e594aa7cded1e70a2ebee.svg";
export { ForwardRef as ReactComponent };